/**
 * check if element exists
 * @param {dom-element} el
 *
 * @return {boolean}
 */
export function getElementExists(el) {
  return el && typeof el !== "undefined" && el !== null;
}

/**
 * get parent element by classname
 * @param {dom-element} el
 * @param {string} cls
 *
 * @return {dom-element} el
 */
export function getParentByClass(el, cls) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.classList.contains(cls)
  );
  return el;
}

/**
 * get parent element by data attribute
 * @param {dom-element} el
 * @param {string} attribute
 *
 * @return {dom-element} el
 */
export function getParentByDataAttribute(el, attribute) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.hasAttribute(attribute)
  );
  return el;
}

/**
 * Gets the parent of an element by tag
 *
 * @param  {dom-element} el
 * @param  {string} tagName
 * @return {dom-element}
 */
export function getParentByTag(el, tagName) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.tagName.toLowerCase() != tagName.toLowerCase()
  );
  return el;
}

/**
 * Gets the parent of an element by ID
 *
 * @param  {dom-element} el
 * @param  {string} id
 * @return {dom-element}
 */
export function parentById(el, id) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.id != id
  );
  return el;
}

/**
 * Gets the parent of an element by attribute-value
 *
 * @param  {dom-element} el
 * @param  {string} attr
 * @param  {string} value
 * @return {dom-element}
 */
export function parentByAttributeValue(el, attr, value) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.getAttribute(attr) != value
  );
  return el;
}

/**
 * Checks if an full element is in viewport
 *
 * @param {dom-element} el
 */
export function isInViewport(el) {
  const bounding = el.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Checks if an part of the element is in viewport
 *
 * @param {dom-element} el
 */
export function isPartOfViewport(el) {
  const bounding = el.getBoundingClientRect();
  // return (
  //   bounding.bottom >= 0 &&
  //   bounding.top <=
  //     (window.innerHeight || document.documentElement.clientHeight) &&
  //   bounding.left >= 0 &&
  //   bounding.right <=
  //     (window.innerWidth || document.documentElement.clientWidth)
  // );
  return (
    bounding.bottom >= 0 &&
    bounding.top <=
      (window.innerHeight || document.documentElement.clientHeight)
  );
}

/* Checks if the element is just before reaching viewport
 *
 * @param {dom-element} el
 */
export function isJustBeforeViewport(el, gap = 0) {
  const bounding = el.getBoundingClientRect();

  return (
    bounding.bottom + gap >= 0 &&
    bounding.top - gap <=
      (window.innerHeight || document.documentElement.clientHeight)
  );
}

/**
 * Checks if an element is in the center of viewport
 *
 * @param {dom-element} el
 */
export function isInViewportCenter(el) {
  const bounding = el.getBoundingClientRect();
  const vieportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  return (
    bounding.top <= vieportHeight / 2 &&
    bounding.left >= 0 &&
    bounding.bottom >= vieportHeight / 2 &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Check browser support of single css property
 * @param {string} property
 * @return {boolean}
 */
export function isCSSPropertySupported(property) {
  return property in document.body.style;
}

/**
 * Check if the paramater is a function
 * @param {function} functionToCheck
 * @return {boolean}
 */
export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}

/**
 * Set browser cookie with execurion date
 * @param {string} cname
 * @param {string} cvalue
 * @param {string} exdays
 * @param {string} domain
 */
export function setCookie(cname, cvalue, exdays, domain = globalvars["host"]) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/;";
}

/**
 * Get single cookie
 * @param {string} cname
 */
export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Delete single cookie
 * @param {string} cname
 * @param {string} domain
 */
export function deleteCookie(cname, domain = globalvars["host"]) {
  document.cookie =
    cname +
    "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" +
    domain +
    "; path=/;";
}

/**
 * IE10 classList support
 * Method that checks whether cls is present in element object.
 * @param  {Object} ele DOM element which needs to be checked
 * @param  {Object} cls Classname is tested
 * @return {Boolean} True if cls is present, false otherwise.
 */
export function hasClass(ele, cls) {
  return (
    ele.hasAttribute("class") && ele.getAttribute("class").indexOf(cls) > -1
  );
}

/**
 * Method that adds a class to given element.
 * @param  {Object} ele DOM element where class needs to be added
 * @param  {Object} cls Classname which is to be added
 * @return {null} nothing is returned.
 */
export function addClass(ele, cls) {
  if (typeof ele !== "undefined" && ele !== null) {
    if (ele.classList) {
      ele.classList.add(cls);
    } else if (!hasClass(ele, cls)) {
      ele.setAttribute("class", ele.getAttribute("class") + " " + cls);
    }
  }
}

/**
 * Method that does a check to ensure that class is removed from element.
 * @param  {Object} ele DOM element where class needs to be removed
 * @param  {Object} cls Classname which is to be removed
 * @return {null} Null nothing is returned.
 */
export function removeClass(ele, cls) {
  if (typeof ele !== "undefined" && ele !== null) {
    if (ele.classList) {
      ele.classList.remove(cls);
    } else if (hasClass(ele, cls)) {
      ele.setAttribute("class", ele.getAttribute("class").replace(cls, " "));
    }
  }
}

/**
 * Get Element offset in page
 * @param {Element} el
 * @return {Object}
 * Access: el.left, el.top
 */
export function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

/**
 * PERFORMANCE
 * Method to set all event listener passive by default
 * to speedup in modern browsers
 *
 * Source: https://github.com/zzarcon/default-passive-events/blob/master/dist/index.js
 * Explainer: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * alternative Polyfill: https://github.com/WICG/EventListenerOptions/blob/gh-pages/EventListenerOptions.polyfill.js
 *
 * e.g. window.addEventListener("scroll", function () {}, { passive: true });
 */
export function setPassiveEventListeners() {
  var e,
    t = [
      "scroll",
      "wheel",
      "touchstart",
      "touchmove",
      "touchenter",
      "touchend",
      "touchleave",
      "mouseout",
      "mouseleave",
      "mouseup",
      "mousedown",
      "mousemove",
      "mouseenter",
      "mousewheel",
      "mouseover",
    ];
  if (
    (function () {
      var e = !1;
      try {
        var t = Object.defineProperty({}, "passive", {
          get: function () {
            e = !0;
          },
        });
        window.addEventListener("test", null, t),
          window.removeEventListener("test", null, t);
      } catch (e) {}
      return e;
    })()
  ) {
    var o = EventTarget.prototype.addEventListener;
    (e = o),
      (EventTarget.prototype.addEventListener = function (o, r, n) {
        var s,
          a = "object" == typeof n && null !== n,
          i = a ? n.capture : n;
        ((n = a
          ? (function (e) {
              var t = Object.getOwnPropertyDescriptor(e, "passive");
              return t && !0 !== t.writable && void 0 === t.set
                ? Object.assign({}, e)
                : e;
            })(n)
          : {}).passive =
          void 0 !== (s = n.passive) ? s : -1 !== t.indexOf(o) && !0),
          (n.capture = void 0 !== i && i),
          e.call(this, o, r, n);
      }),
      (EventTarget.prototype.addEventListener._original = e);
  }
}

/**
 * Get EventListener passive mode if supported
 * @returns {any}
 */
export function getPassiveEventListenerSupport() {
  let supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  return supportsPassive;
}

/**
 *
 * @returns Get correct and supported wheel event
 */
export function getCorrectWheelEvent() {
  return "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";
}

/**
 * Returns string optimized for url or css class
 * @param {string} value
 * @return {string} value
 */
export function getUrlLabel(value) {
  value = value.toLowerCase();
  value = value.replace(/ä/g, "ae");
  value = value.replace(/ö/g, "oe");
  value = value.replace(/ü/g, "ue");
  value = value.replace(/ß/g, "ss");
  value = value.replace(/ /g, "-");
  value = value.replace(/\./g, "");
  value = value.replace(/,/g, "");
  value = value.replace(/\(/g, "");
  value = value.replace(/\)/g, "");
  return value;
}

/**
 * Add or Replace url parameter
 * Example: location.href = addParameterToUrl(window.location.href, 'timestamp', Date.now());
 * @param {string} url
 * @param {string} param
 * @param {string} value
 * @returns
 */
export function addParameterToUrl(url, param, value) {
  let hash = {};
  let parser = document.createElement("a");

  parser.href = url;

  let parameters = parser.search.split(/\?|&/);

  for (let i = 0; i < parameters.length; i++) {
    if (!parameters[i]) continue;

    let ary = parameters[i].split("=");
    hash[ary[0]] = ary[1];
  }

  hash[param] = value;

  let list = [];
  Object.keys(hash).forEach(function (key) {
    list.push(key + "=" + hash[key]);
  });

  parser.search = "?" + list.join("&");
  return parser.href;
}

/**
 * Function to watch mouse wheel stops
 * @param {dom} element
 * @param {function} callback
 * @param {int} timeout
 * @returns
 */
export function createWheelStopListener(element, callback, timeout) {
  var handle = null;
  var onScroll = function () {
    if (handle) {
      clearTimeout(handle);
    }
    handle = setTimeout(callback, timeout || 200); // default 200 ms
  };
  element.addEventListener("wheel", onScroll);
  return function () {
    element.removeEventListener("wheel", onScroll);
  };
}

/**
 * Smooth scroll to element with ID
 * @param {string} anchor
 * @param {int} offset
 * @returns
 */
export function scrollToID(anchor, offset = 0) {
  const id = anchor.replace("#", "");
  const target = document.getElementById(id);

  console.log(anchor, id, target);

  if (!target) return false;

  window.scrollTo({
    top: target.offsetTop + offset,
    behavior: "smooth",
  });

  return true;
}

/**
 * Fade in element
 */
export function fadeOut(element) {
  if (!element) return;
  let op = 1; // initial opacity
  let timer = setInterval(function () {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = "none";
    }
    element.style.opacity = op;
    element.style.filter = "alpha(opacity=" + op * 100 + ")";
    op -= op * 0.1;
  }, 50);
}

/**
 * Fade out element
 */
export function fadeIn(element, display = "block") {
  if (!element) return;
  let op = 0.1; // initial opacity
  element.style.display = display;
  let timer = setInterval(function () {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    element.style.filter = "alpha(opacity=" + op * 100 + ")";
    op += op * 0.1;
  }, 10);
}

/**
 * Add innerHtml and running included scripts
 */
export function setInnerHTML(elm, html) {
  elm.innerHTML = html;

  Array.from(elm.querySelectorAll("script")).forEach((oldScriptEl) => {
    const newScriptEl = document.createElement("script");

    Array.from(oldScriptEl.attributes).forEach((attr) => {
      newScriptEl.setAttribute(attr.name, attr.value);
    });

    const scriptText = document.createTextNode(oldScriptEl.innerHTML);
    newScriptEl.appendChild(scriptText);

    oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  });
}

/**
 * Validate email input
 * Source: https://www.regular-expressions.info/email.html
 */
export function validateEmailInput(input) {
  const validRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (input.value.toLowerCase().match(validRegex)) {
    return true;
  } else {
    return false;
  }
}

/**
 * Validate telephone input
 */
export function validateTeleInput(input) {
  const validRegex =
    /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/g;

  if (input.value.toLowerCase().match(validRegex)) {
    return true;
  } else {
    return false;
  }
}

/**
 * Video observer for lazyloading
 */
export function lazyLoadVideoSrc(video = null, play = true) {
  if ("IntersectionObserver" in window) {
    let lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (let source in video.target.children) {
            let videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              if (window.innerWidth <= 650 && videoSource.dataset.srcSmall) {
                //optional mobile lazy-loading data-src-small
                videoSource.src = videoSource.dataset.srcSmall;
              } else if (videoSource.dataset.src) {
                // lazy-loading data-src
                videoSource.src = videoSource.dataset.src;
              }
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideoObserver.observe(video);
  }
}

/**
 * Check is mobile device
 * Use JS to fix cache issues
 */
export function mobileAndTabletCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
